module.exports = __webpack_public_path__ + "img/utilitylight_driving.741caa5a.svg";